import { KeyValuePair } from './key-value-pair';
import { Uri } from './uri';

export class HttpRequest<T> {
  token?: string;
  verb: string;
  uri: Uri;
  httpVersion: string;
  headers: KeyValuePair[];
  body: any;

  constructor() {
    this.uri = new Uri();
    this.headers = [];
  }

  addQueryParameter(key: string, value: string) {
    this.uri.queryParameters.push(new KeyValuePair(key, value));
  }

  addHeader(key: string, value: string) {
    this.headers.push(new KeyValuePair(key, value));
  }
}




// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/http-request.ts